import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f03bddca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box-filter" }
const _hoisted_2 = { class: "icon-filter-button" }
const _hoisted_3 = ["src"]

export function render(_ctx, _cache) {
  const _directive_outside = _resolveDirective("outside")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", {
      onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.onFilter && _ctx.onFilter(...args))),
      onKeydown: [
        _cache[2] || (_cache[2] = (...args) => (_ctx.handleKeyDown && _ctx.handleKeyDown(...args))),
        _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
      ],
      tabindex: "0",
      class: _normalizeClass([{'active' : _ctx.isDropdown}, "row c-filter"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: require('@/assets/icons/sidebars/filter.svg'),
          alt: ""
        }, null, 8, _hoisted_3)
      ]),
      (_ctx.isDropdown)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass([{'c-filter-dropdown-active' : _ctx.isDropdown}, "c-filter-dropdown"])
          }, [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
              class: "c-filter-dropdown-item"
            }, [
              _renderSlot(_ctx.$slots, "filter", {}, undefined, true)
            ])
          ], 2))
        : _createCommentVNode("", true)
    ], 34)), [
      [_directive_outside, _ctx.outsideClick]
    ])
  ]))
}